.carouselViewport {
  position: relative;
  overflow: hidden;
  width: 100%;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  cursor: pointer;
  border-radius: 24px;
}

.carouselTrack {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  overscroll-behavior-inline: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}

.carouselTrack::-webkit-scrollbar {
  display: none;
}

@media (prefers-reduced-motion: reduce) {
  .carouselTrack {
    scroll-behavior: auto;
  }
}
